/* global gtag */
import React, { useState,useContext ,useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX ,faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import OtherDetails from '../Components/OtherDetails';
import ZonesAndHubsDetails from '../Components/ZonesAndHubsDetails';
import Address from '../Components/Address';
import ContactPersons from '../Components/ContactPersons';
import { Loader ,Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import {  useLocation } from 'react-router-dom'
import { decryptData } from '../../utils/storageCrypto';

function NewCustomer() {
  const location = useLocation();

  const navigate = useNavigate();
  const [showOtherDetails, setShowOtherDetails] = useState(false);
  const [showAddress, setShowAddress] = useState(true);
  const [showContactPersons, setShowContactPersons] = useState(false);
  const [showZones, setShowZones] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errors, setErrors] = useState({ email:'', mobile_number: '',gstin: '', pan: '' });
  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [sidebarClicked, setSidebarClicked] = useState(false)
  const [buyerTypes, setBuyerTypes] = useState([]);
  console.log(buyerTypes)
  const [data, setData] = useState({
    mobile_number: '',
    email: '',
    customer_name: '',
    company_name: '',
    type_of_firm: '',
    gstin: '',
    pan: '',
    city: '',
    association: '',
    customer_type:'',
    address: '',
    state:'',
    pincode: ''
  });

  const [otherDetails, setOtherDetails] = useState({
    gstin: '',
    pan: '',
    city: '',
    state:''
  });

  // ✅ zones is an array — a customer can operate in multiple zones, each with
  // its own gstin/pan/address/city/state/pincode/hubs, matching the schema's
  // `zones: [{ zone, gstin, pan, address1, city, pincode, state, hubs, is_primary }]`
  const emptyZone = () => ({
    zone: '',       // ObjectId ref -> 'Zone'
    gstin: '',
    pan: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    hubs: [],       // array of ObjectId ref -> 'Hub'
    is_primary: false,
  });

  const [zones, setZones] = useState([{ ...emptyZone(), is_primary: true }]);

  const [address, setAddress] = useState({
    address: '',
    city: '',
    state: '',
    pincode: '',
  });

  const [contactPersons, setContactPersons] = useState([
    { name: '', email: '', mobile_number: '', designation: '' }
  ]);


useEffect(() => {
  const fetchBuyerTypes = async () => {
    try {
      const encryptedToken = sessionStorage.getItem('token');
      const token = decryptData(encryptedToken);

      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/get-buyer-types`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });

      const resData = await response.json();
      console.log("resData:",resData);
      if (resData.status === 200 && resData.data) {
        // Convert object values into an array: ['Individual Buyer', 'Home Builder', ...]
        const typesList = Array.isArray(resData.data)
          ? resData.data
          : Object.values(resData.data);

        setBuyerTypes(typesList);
      }
    } catch (err) {
      console.error('Error fetching buyer types:', err);
    }
  };

  fetchBuyerTypes();
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setErrorMessages((prev) =>
  prev.filter((msg) => !msg.toLowerCase().includes(name.replace("_", " ")))
);
  
    // General validation for all fields
  if (name === 'mobile_number') {
  // allow only digits
  if (!/^[0-9]*$/.test(value)) return;

  // limit max length (12 safe for all types)
  if (value.length > 12) return;

  setData((prev) => ({
    ...prev,
    mobile_number: value,
  }));

  let error = '';

  if (value.length > 0) {
    if (/^[6-9]\d{9}$/.test(value)) {
      // ✅ Mobile
      error = '';
    } 
    else if (/^1800\d{6,7}$/.test(value)) {
      // ✅ Toll-free
      error = '';
    } 
    else if (/^(0\d{10,11}|1\d{9,11})$/.test(value)) {
      // ✅ Landline / customer care
      error = '';
    } 
    else {
      error = 'Enter a valid Mobile number';
    }
  }

  setErrors((prev) => ({
    ...prev,
    mobile_number: error,
  }));
}
  
    if (name === 'email') {
      if (value === '') {
        setErrors((prevState) => ({ ...prevState, email: '' })); // Clear error message if email field is empty
      } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          setErrors((prevState) => ({ ...prevState, email: 'Please enter a valid email address' }));
        } else {
          setErrors((prevState) => ({ ...prevState, email: '' }));
        }
      }
      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  
    // Handle changes for other fields
    if (name === 'customer_name' || name === 'company_name' || name === 'type_of_firm' || name === 'customer_type' || name === 'association'|| name === 'city' ||
  name === 'state' ) {
      setData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
      
    }
  };

const handleChangeOtherDetails = (e) => {
  const { name, value } = e.target;

 setErrorMessages((prev) =>
  prev.filter((msg) => {
    const text = msg.toLowerCase();

    if (name === "gstin") return !text.includes("gst");
    if (name === "pan") return !text.includes("pan");

    return !text.includes(name.replace("_", " "));
  })
);

  if (name === "gstin") {
    // Always update gstin
    setOtherDetails((prev) => ({ ...prev, gstin: value }));

    if (value.length === 15) {
      const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (gstinRegex.test(value)) {
        const panNumber = value.substring(2, 12);
        setOtherDetails((prev) => ({
          ...prev,
          gstin: value,
          pan: panNumber, // ✅ Auto-populate PAN
        }));
        setErrors((prev) => ({ ...prev, gstin: "" }));
         setErrorMessages((prev) =>
    prev.filter((msg) => !msg.toLowerCase().includes("pan"))
  );
  
      } else {
        setErrors((prev) => ({ ...prev, gstin: "Invalid GSTIN format" }));
        setOtherDetails((prev) => ({ ...prev, pan: "" })); // ❌ Reset PAN
      }
    } else {
      // ❌ If GST is removed or not 15 digits → reset PAN
      setOtherDetails((prev) => ({ ...prev, pan: "" }));
      if (value === "") {
        setErrors((prev) => ({ ...prev, gstin: "" }));
      }
    }
  }
    // ✅ Default case (city, state, etc.)
  setOtherDetails((prev) => ({
    ...prev,
    [name]: value,
  }));
};


  const handleDropdownChange = (value) => {
    setOtherDetails((prevDetails) => ({
      ...prevDetails,
      state: value,
    }));
  };

  const handleAddressDropdownChange = (value) => {
    setAddress((prevDetails) => ({
      ...prevDetails,
      state: value,
    }));
  }; 


  const handleChangeAddress = (e) => {
    const { name, value } = e.target;
    setAddress((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleChangeContact = (updatedContacts) => {
    setContactPersons(updatedContacts);
  };

  const addContactPerson = () => {
    setContactPersons([...contactPersons, { name: '', email: '', mobile_number: '', designation: '' }]);
  };

  const removeContactPerson = (index) => {
    const updatedContacts = contactPersons.filter((_, i) => i !== index);
    setContactPersons(updatedContacts);
  };

  // ---- Zones & Hubs handlers (array-based: one block per zone) ----
  // Generic field handler for native inputs (gstin, pan, address, city, pincode)
const handleChangeZoneDetails = (index, e) => {
    const { name, value } = e.target;

    // Clear related error messages upon typing
    setErrorMessages((prev) =>
      prev.filter((msg) => {
        const text = msg.toLowerCase();
        if (name === "gstin") return !text.includes("gst");
        if (name === "pan") return !text.includes("pan");
        return !text.includes(name.replace("_", " "));
      })
    );

    setZones((prev) => {
      const updated = [...prev];

      if (name === "gstin") {
        updated[index] = { ...updated[index], gstin: value };

        if (value.length === 15) {
          const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
          
          if (gstinRegex.test(value)) {
            const panNumber = value.substring(2, 12);
            updated[index] = { ...updated[index], pan: panNumber }; // ✅ Auto-populate PAN

            setErrors((prevErr) => ({ ...prevErr, gstin: "" }));
            setErrorMessages((prevMsgs) =>
              prevMsgs.filter((msg) => !msg.toLowerCase().includes("pan"))
            );
          } else {
            setErrors((prevErr) => ({ ...prevErr, gstin: "Invalid GSTIN format" }));
            updated[index] = { ...updated[index], pan: "" }; // ❌ Reset PAN on invalid GSTIN
          }
        } else {
          // ❌ If GSTIN is modified and not 15 digits → reset PAN
          updated[index] = { ...updated[index], pan: "" };
          if (value === "") {
            setErrors((prevErr) => ({ ...prevErr, gstin: "" }));
          }
        }
      } else {
        // ✅ Default case (pan, address, city, etc.)
        updated[index] = { ...updated[index], [name]: value };
      }

      return updated;
    });
  };

  // Zone dropdown selection (CustomDropdown calls onSelect(value, label, id))
  const handleZoneChange = (index, value) => {
    setZones((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], zone: value };
      return updated;
    });
  };

  // State dropdown selection within a zone block
  const updateZoneState = (index, value, label) => {
    setZones((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], state: label };
      return updated;
    });
  };

  // Hubs multiselect for a zone block
  const handleZoneHubsChange = (index, updatedHubs) => {
    setZones((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], hubs: updatedHubs };
      return updated;
    });
  };

  const addZone = () => {
    setZones((prev) => [...prev, emptyZone()]);
  };

  const removeZone = (index) => {
    setZones((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      // Always keep exactly one primary zone if any remain
      if (updated.length > 0 && !updated.some((z) => z.is_primary)) {
        updated[0] = { ...updated[0], is_primary: true };
      }
      return updated;
    });
  };

  const setPrimaryZone = (index) => {
    setZones((prev) => prev.map((z, i) => ({ ...z, is_primary: i === index })));
  };


const handleSubmit = async (attempt = 1) => {
  const errorMessages = [];
  if (!data.customer_name) {
    errorMessages.push('Enter Customer Name.');
  }
 if (!data.mobile_number || data.mobile_number.trim() === '') {
  errorMessages.push('Please enter a mobile number.');
}
  if (data.email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(data.email)) {
      errorMessages.push('Please enter a valid email address.');
    }
  }
/*   if (!otherDetails.gstin) {
    errorMessages.push('Please enter the GST.');
  } else {
    const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (!gstinRegex.test(otherDetails.gstin)) {
      errorMessages.push('Invalid GSTIN format.');
    }
  }
  if (!otherDetails.pan) {
    errorMessages.push('Please enter the PAN.');
  } else {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panRegex.test(otherDetails.pan)) {
      errorMessages.push('Invalid PAN format.');
    }
  } */
  if (errorMessages.length > 0) {
    setErrorMessages(errorMessages);
    return;
  }

  setIsSaving(true);

  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const saveUrl = `${fetchUrl}customer/create-customer`;
    const addressString = `${address.address} ${address.city} ${address.state} ${address.pincode}`;
    const encryptedHubId = sessionStorage.getItem('hubId');
    const hubId = decryptData(encryptedHubId);

    // Only send zone entries that actually have a zone selected
    // (schema requires `zone` per entry in the zones array)
    const validZones = zones.filter((z) => z.zone);
    const zonesPayload = validZones.map((z, i) => ({
      zone: z.zone,
      gstin: z.gstin,
      pan: z.pan,
      address1: z.address,
      city: z.city,
      state: z.state,
      pincode: z.pincode,
      hubs: z.hubs,
      // Guarantee exactly one primary: honor is_primary if set, else default to the first entry
      is_primary: validZones.some((v) => v.is_primary) ? !!z.is_primary : i === 0,
    }));
    const primaryZone = zonesPayload.find((z) => z.is_primary) || zonesPayload[0];

    const requestData = {
      ...data,
      // Top-level gstin/pan/city/state/pincode mirror the primary zone's values when the
      // Zones & Hubs tab has been filled in, falling back to the Business Details tab otherwise.
      gstin: primaryZone?.gstin || data.gstin || otherDetails.gstin,
      pan: primaryZone?.pan || data.pan || otherDetails.pan,
      city: primaryZone?.city || data.city || otherDetails.city || address.city,
      state: primaryZone?.state || data.state || otherDetails.state || address.state,
      pincode: primaryZone?.pincode || data.pincode || address.pincode,
      address: addressString,
      hubId: hubId,
      ...(zonesPayload.length > 0 && { zones: zonesPayload }),
      ...(contactPersons?.[0]?.mobile_number !== '' && { customerContacts: contactPersons }),
    };


    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    const response = await fetch(saveUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token,
      },
      body: JSON.stringify(requestData),
      signal: controller.signal
    });

    clearTimeout(timeoutId);

    const responseData = await response.json();
    console.log(responseData);
    

    if (responseData.status === 201 || responseData.status === 200 || responseData.status === 204) {
    /*  if (typeof gtag !== "undefined") {
  try {
    console.log("✅ Entered gtag, sending registration event...");

    gtag('event', 'registration_complete', {
      method: 'email',
      user_id: responseData.data._id.toString(),
      created_by: 'BBAdmin',
      customer: responseData.data.customer_name,
      roleId: responseData.data.roleId
    });

    console.log("✅ Registration event sent to GA:", {
      method: 'email',
      user_id: responseData.data._id.toString(),
      created_by: 'BBAdmin',
      customer: responseData.data.customer_name,
      roleId: responseData.data.roleId
    });
  } catch (error) {
    console.error("❌ Failed to send registration event to GA:", error);
  }
} else {
  console.error("❌ gtag is not defined. Google Analytics script not loaded.");
} */

      setIsSaving(false);
      setPopupMessage(responseData.message);
      setPopupType('200or201');
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
        navigate("/admin/app/sales/customerdetails", { state: { CustomerData: responseData.data } });
      }, 3000);
    } else if (response.status === 400) {
      // ✅ Show backend message (Customer exists / GSTIN exists / PAN exists)
      setIsSaving(false);
      setPopupMessage(responseData.message || 'Validation error');
      setPopupType('400');
      setShowPopup(true);
    } else if (response.status === 401) {
      setIsSaving(false);
      setPopupMessage(responseData.message);
      setPopupType('401');
      setShowPopup(true);
    } else if (response.status === 403) {
      setIsSaving(false);
      setPopupMessage(responseData.message);
      setPopupType('403');
      setShowPopup(true);
    } else if (response.status === 500) {
      setIsSaving(false);
      setPopupMessage(responseData.message || 'Internal server error');
      setPopupType('500');
      setShowPopup(true);
    } else {
      setIsSaving(false);
      setPopupMessage('Unknown error');
      setPopupType('500');
      setShowPopup(true);
    }
  } catch (error) {
    console.error('❌ Fetch Failed:', error);
    setIsSaving(false);

    if (error.name === 'AbortError') {
      setPopupMessage('Request timed out. Please check if customer was created before retrying.');
      setPopupType('500');
      setShowPopup(true);
      return;
    }

    if (error.message.includes('JSON') || error.name === 'SyntaxError') {
      setPopupMessage('Response error. Please check if customer was created before retrying.');
      setPopupType('500');
      setShowPopup(true);
      return;
    }

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1);
      setIsSaving(true);
      setTimeout(() => handleSubmit(attempt + 1), 8000);
    } else {
      setIsLoading(false);
      setPopupMessage('Network error occurred. Please verify if customer was created before retrying.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => handleSubmit(1));
    }
  } finally {
    setErrorMessages([]);
  }
};


  if (isLoading) {
    return <Loader />;
  }

  const handleCloseError = () => {
    setErrorMessages([]);
  };

  const closePopup = () => {

    setShowPopup(false);
  };
  
  const Retry = async () => {

    setIsLoading(true); // Show loader
    setTimeout(async () => {
      if (retryFunction) {
        await retryFunction(); // Call retry function
      }
      setIsLoading(false); // Hide loader after retry
    }, 5000); // 5-second delay
    setShowPopup(false);
  };
  
  const BackToLoginPage = () => {

    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/admin');
  };

  const handleCancel = () =>  {
      setShowCancelPopup(true)

  };
  const handleStayHere = () => {
    setShowCancelPopup(false);

  };
  
  const handleLeave = () => {
    setShowCancelPopup(false);  
    navigate(-1);
    
  };
    return (
    <div className="bg-white flex flex-row w-full justify-left h-full overflow-y-hidden">
      <div className="flex flex-row w-full">
        <div className="w-full flex-1">
          <div className="flex flex-col w-full h-full justify-center items-center">
            <div className="w-full h-full flex flex-col justify-between">
              <div className="w-full h-16 border-b flex items-center">
                <div className="flex w-full justify-between px-4 items-center">
                  <h1 className="text-lg font-semibold">New Customer</h1>
                </div>
              </div>
              {errorMessages.length > 0 && (
                <div className="flex justify-between items-center  px-auto py-3  bg-[#fddcde]  rounded-md">
                  <div className="px-6 flex flex-col justify-start items-start">
                    {errorMessages.map((errorMessage, index) => (
                      <span key={index} className="text-sm">
                         •   {errorMessage}
                      </span>
                    ))}
                  </div>
                  <div className='px-4'>
                  <button
                    className="text-gray-700 hover:text-red-500"
                    onClick={handleCloseError}
                  >
                    <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                  </button>
                  </div>
                </div>
              )}
              <div className="flex flex-col justify-start items-start w-full flex-grow h-80 overflow-y-auto">
                <div className="w-full flex flex-col justify-start items-start px-4">
                  {/* Customer Name Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="customerName" className="block text-sm font-regular text-[#e54643] w-1/6">
                      Customer Name<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="customerName"
                      name="customer_name"
                      value={data.customer_name}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                  </div>

                  {/* Company Name Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="companyName" className="block text-sm font-regular text-gray-700 w-1/6">
                      Company Name
                    </label>
                    <input
                      type="text"
                      id="companyName"
                      name="company_name"
                      value={data.company_name}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                  </div>

                  {/* Company Type Dropdown */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="companytype" className="block text-sm font-regular text-gray-700 w-1/6">
                      Company Type
                    </label>
                    <select
                      id="companytype"
                      name="type_of_firm"
                      value={data.type_of_firm}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    >
                      <option value="">Select Company Type</option>
                      <option value="private">Private</option>
                      <option value="public">Public</option>
                      <option value="partnership">Partnership</option>
                      <option value="soleproprietorship">Sole Proprietorship</option>
                      {/* Add more options as needed */}
                    </select>
                  </div>

                  {/* Customer Type Dropdown */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="customertype" className="block text-sm font-regular text-gray-700 w-1/6">
                      Customer Type
                    </label>
                    <select
                      id="customertype"
                      name="customer_type"
                      value={data.customer_type}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    >
                      <option value="">Select Customer Type</option>
                      {buyerTypes.map((type, index) => {
                        // Handles both string array: ['Home Builder', ...] 
                        // or object array: [{ label: 'Home Builder', value: 'Home Builder' }, ...]
                        const value = typeof type === 'object' && type !== null ? (type.value || type.name || type.type) : type;
                        const label = typeof type === 'object' && type !== null ? (type.label || type.name || type.type) : type;

                        return (
                          <option key={index} value={value}>
                            {label}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  {/* Association Dropdown */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="association" className="block text-sm font-regular text-gray-700 w-1/6">
                      Association
                    </label>
                    <select
                      id="association"
                      name="association"
                      value={data.association}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    >
                      <option value="">Select Association</option>
                      <option value="naredco">NAREDCO</option>
                      <option value="credai">CREDAI</option>
                      <option value="bai">BAI</option>
                      {/* Add more options as needed */}
                    </select>
                  </div>

                  {/* Email Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="email" className="block text-sm font-regular text-gray-700 w-1/6">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={data.email}
                      onChange={handleChange}
                     className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
                  </div>

                  {/* Mobile Label and Input */}
                  <div className="w-full flex flex-row items-center mb-4 space-x-2 mt-5">
                    <label htmlFor="mobile" className="block text-sm font-regular text-[#e54643] w-1/6">
                      Mobile*
                    </label>
                    <input
                      type="text"
                      id="mobile"
                      name="mobile_number"
                      value={data.mobile_number}
                      onChange={handleChange}
                      className="w-1/3 outline-none block rounded-md border border-gray-300 hover:border-blue-500 focus:border-blue-500 focus:ring focus:ring-blue-200 focus:ring-opacity-50 p-2 text-sm text-gray-700"
                    />
                    {errors.mobile_number && <p className="text-red-500 text-sm">{errors.mobile_number}</p>}
                  </div>

                  <div className='flex w-full items-center border-b'>
                    <div className="w-full flex flex-row space-x-2">
{/*                       <button
                        className={`w-1/6 p-2 text-sm ${showOtherDetails ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(true);
                          setShowAddress(false);
                          setShowContactPersons(false);
                          setShowZones(false);
                        }}
                      >
                        Business Details
                      </button> */}
                      <button
                        className={`w-1/6 p-2 text-sm ${showAddress ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(true);
                          setShowContactPersons(false);
                          setShowZones(false);
                        }}
                      >
                        Address
                      </button>
                      <button
                        className={`w-1/6 p-2 text-sm ${showContactPersons ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(false);
                          setShowContactPersons(true);
                          setShowZones(false);
                        }}
                      >
                        Contact Persons
                      </button>
                      <button
                        className={`w-1/6 p-2 text-sm ${showZones ? 'text-[#21263C] font-medium border-b-2 border-blue-500' : ''}`}
                        onClick={() => {
                          setShowOtherDetails(false);
                          setShowAddress(false);
                          setShowContactPersons(false);
                          setShowZones(true);
                        }}
                      >
                       Business Details, Zones & Hubs
                      </button>
                    </div>
                  </div>

                  {/* Other Details Section */}
{/*                   {showOtherDetails &&  <OtherDetails
          gstin={otherDetails.gstin}
          pan={otherDetails.pan}
          city={otherDetails.city}
          state={otherDetails.state}
          onChange={handleChangeOtherDetails}
          errors={errors}
          updateState={handleDropdownChange}
          showAddress={false} 
          showPincode={false}
        />} */}

                  {/* Address Section */}
                  {showAddress && <Address
          address={address.address}
          city={address.city}
          state={address.state}
          pincode={address.pincode}
          onChange={handleChangeAddress}
          updateAddressState={handleAddressDropdownChange}
        />}
                  {/* Contact Persons Section */}
                  {showContactPersons && <ContactPersons
                  contactPersons={contactPersons}
                  onChange={handleChangeContact}
                  addContactPerson={addContactPerson}
                  removeContactPerson={removeContactPerson}
                   showRole={false}
                />
                }

                  {/* Zones & Hubs Section */}
                  {showZones && (
                    <div className="w-full flex flex-col">
                      {zones.map((z, index) => (
                        <div key={index} className="w-full border rounded-md mb-4 p-3">
                          <div className="w-full flex justify-between items-center mb-2">
                            <div className="flex items-center space-x-2">
                              <span className="text-sm font-medium text-[#21263C]">Zone {index + 1}</span>
                              <label className="flex items-center space-x-1 text-xs text-gray-600 cursor-pointer">
                                <input
                                  type="radio"
                                  name="primary_zone"
                                  checked={!!z.is_primary}
                                  onChange={() => setPrimaryZone(index)}
                                />
                                <span>Primary</span>
                              </label>
                            </div>
                            {zones.length > 1 && (
                              <button
                                type="button"
                                className="text-xs text-[#F7525A] hover:underline"
                                onClick={() => removeZone(index)}
                              >
                                Remove
                              </button>
                            )}
                          </div>
                          <ZonesAndHubsDetails
                            zone={z.zone}
                            onZoneChange={(value) => handleZoneChange(index, value)}
                            gstin={z.gstin}
                            pan={z.pan}
                            address={z.address}
                            city={z.city}
                            state={z.state}
                            pincode={z.pincode}
                            onChange={(e) => handleChangeZoneDetails(index, e)}
                            errors={errors}
                            updateState={(value, label) => updateZoneState(index, value, label)}
                            hubs={z.hubs}
                            onHubsChange={(updatedHubs) => handleZoneHubsChange(index, updatedHubs)}
                          />
                        </div>
                      ))}
                      <button
                        type="button"
                        className="self-start px-2 py-1 text-sm text-[#f7525a] border border-[#f7525a] rounded-md hover:bg-[#fddcde]"
                        onClick={addZone}
                      >
                        + Add Zone
                      </button>
                    </div>
                  )}
                </div>
                </div>
                <div className="mt-5 w-full">
                  <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
                  <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
                    <button className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center" onClick={handleSubmit}>
                      <span>Save</span>
                      {isSaving && <Spinner />}
                    </button>
                    <button  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
          isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
        }`}
        disabled={isSaving}
         onClick={handleCancel}>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
         
        </div>
      </div>

      {showCancelPopup && (
    <div className="fixed inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50 ">
    <div className="bg-white rounded-b-md shadow-md w-[550px] h-[250px] flex flex-col" style={{ maxWidth: '550px', maxHeight: '250px' }}>
    <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-14 px-6'>
    <h2 className="text-md font-semibold">
    <FontAwesomeIcon icon={faExclamationTriangle} className="text-xl text-yellow-500 mr-4 " />
      Leave this page?</h2>
      <button onClick={handleStayHere} className="text-white px-1 py-1 rounded-md ">   
        <FontAwesomeIcon icon={faX} className="text-xs text-[#212529] cursor-pointer " />
      </button>
    </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      <div className='pt-4 pl-4 '>
    <div className="w-full items-center p-5">
      <label htmlFor="Other_details" className="block text-sm font-regular text-[#212529] ">
      If you leave, your unsaved changes will be discarded.
      </label>
    </div>  
  </div>
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="text-sm flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
        <button className="px-2 py-1 bg-[#408dfb] border-[#f7525a] text-white rounded-md" onClick={handleStayHere}>
  Stay Here  {isSaving && (
      <Spinner/>
    )}
  </button>
          <button onClick={handleLeave} 
          className="hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50  px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md">
            Leave & Discard Changes</button>
        </div>
      </div>
    </div>
  </div>
)}
      {showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}
    </div>
  );
}

export default NewCustomer;